import { getNamedType } from "graphql";
const FIELD_LIST_THRESHOLD = 20;
function fieldMatchesFilter(field, query) {
  var _a;
  const q = query.trim().toLowerCase();
  if (q === "") {
    return true;
  }
  if (field.name.toLowerCase().includes(q)) {
    return true;
  }
  if ((_a = field.description) == null ? void 0 : _a.toLowerCase().includes(q)) {
    return true;
  }
  return getNamedType(field.type).name.toLowerCase().includes(q);
}
function selectVisibleFields({
  fields,
  isSelected,
  threshold,
  expanded,
  filter
}) {
  if (filter.trim() !== "") {
    return {
      visible: fields.filter((f) => fieldMatchesFilter(f, filter)),
      hiddenCount: 0
    };
  }
  if (expanded || fields.length <= threshold) {
    return {
      visible: fields,
      hiddenCount: 0
    };
  }
  const visible = fields.filter((field, index) => index < threshold || isSelected(field.name));
  return {
    visible,
    hiddenCount: fields.length - visible.length
  };
}
export {
  FIELD_LIST_THRESHOLD,
  fieldMatchesFilter,
  selectVisibleFields
};
//# sourceMappingURL=field-list-view.js.map
